// Heartbeat interval.
export const HEARTBEAT_INTERVAL = 15 * 1000

// Re-login time threshold.
export const RELOGIN_TIME_THRESHOLD = 1 * 60 * 1000

// Delay before trying to auto login.
export const AUTO_LOGIN_TIMEOUT = 100
